import { alanMarkdown } from '../../../../alan_btn/src/textChat/alanMarkdown';
import { HL_BRACKET_KEYWORDS_REGEX } from '../../views/pages/project/TransformMode/transformTextHighlight';


export function getMarkdownWithTransformFixes(value) {
    return alanMarkdown((value || '')?.replace(new RegExp(HL_BRACKET_KEYWORDS_REGEX), match => `${match}\n`) || '');
}
